import { ClassroomContentOptions } from "../pages/classroom/main/Classroom";

export const ROUTE_CLASSROOM_ID = ":classroomId";

export function routeClassroom(schoolId: string, classroomId: string, tab?: ClassroomContentOptions): string {
    return `/school/${schoolId}/classroom/${classroomId}${tab ? `#${tab}` : ""}`;
}

export function routeClassroomEdit(schoolId: string, classroomId: string): string {
    return `/school/${schoolId}/classroom/${classroomId}/edit`;
}

export function routeClassroomImage(schoolId: string, classroomId: string): string {
    return `/school/${schoolId}/classroom/${classroomId}/image`;
}

export function routeClassroomNew(schoolId: string): string {
    return `/school/${schoolId}/classroom/new`;
}

export function routeClassroomStudentAdd(schoolId: string, classroomId: string): string {
    return `/school/${schoolId}/classroom/${classroomId}/student/add`;
}

// export function routeClassroomUserAdd(schoolId: string, classroomId: string): string {
//     return `/school/${schoolId}/classroom/${classroomId}/user/new`;
// }

// export function routeClassroomImagesAdd(schoolId: string, classroomId: string): string {
//     return `/school/${schoolId}/classroom/${classroomId}/images/add`;
// }